import { IByLoggedUser, IPermissionCollection } from 'models/permission';
import { axiosEndPoint } from 'utils/axios';

const path = '/permission';

export const getPermissionList = async () => {
  const response = await axiosEndPoint.get<IPermissionCollection[]>(`${path}`);
  return response.data;
};

export const getPermissionListByApplication = async () => {
  const response = await axiosEndPoint.get<IPermissionCollection[]>(
    `${path}/by-application`
  );
  return response.data;
};

export const getPermissionByLoggedUser = async () => {
  const response = await axiosEndPoint.get<IByLoggedUser>(
    `${path}/by-logged-user`
  );
  return response.data;
};
